import React from 'react'
// IMAGES
import imageRond1 from '../../../images/rond1.png'
import imageRond1ok from '../../../images/rond1ok.png'
import imageRond2 from '../../../images/rond2.png'
import imageRond2ok from '../../../images/rond2ok.png'
import imageRond3 from '../../../images/rond3.png'
import imageRond3ok from '../../../images/rond3ok.png'
import imageRond4 from '../../../images/rond4.png'
import imageRond4ok from '../../../images/rond4ok.png'
import imageRond5 from '../../../images/rond5.png'
import imageRond5ok from '../../../images/rond5ok.png'
import ButtonModalClose from '../../elements/ButtonModalClose'

const ModalStaff = ({ handleChange, handleAddStaff, values, setValues, setCount, count }) => {

    return (
        <div className="modal fade" id="modalStaff" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalStaff">Ajouter un équipier</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setCount(count + 1)}></button>
                    </div>
                    <div className="modal-body">

                        {/* SURNAME STAFF */}
                        <input 
                            type="text" 
                            className="form-control border-0 rounded-pill shadow p-2 mt-3" 
                            placeholder="Ajouter un prénom" 
                            name='surnameStaff' 
                            onChange={handleChange} 
                            value={values.surnameStaff} 
                        />

                        {/* NAME STAFF */}
                        <input 
                            type="text" 
                            className="form-control border-0 rounded-pill shadow p-2 mt-3" 
                            placeholder="Ajouter un nom" 
                            name='nameStaff' 
                            onChange={handleChange} 
                            value={values.nameStaff} 
                        />

                        {/* PHONE STAFF */}
                        <input 
                            type="text" 
                            className="form-control border-0 rounded-pill shadow p-2 mt-3" 
                            placeholder="Ajouter un téléphone" 
                            name='phoneStaff' 
                            onChange={handleChange} 
                            value={values.phoneStaff} 
                        />

                        {/* BOX COLORS */}
                        <div className='row mt-3 ms-1'>
                            <div className='col-2' onClick={() => setValues(prev => ({ ...prev, circleColor:'7ddbd3ff' }))}>
                                {values.circleColor === '7ddbd3ff' ? 
                                    <img src={imageRond1ok} alt='image couleur' style={{ height:45, width:45 }} />
                                : 
                                    <img src={imageRond1} alt='image couleur' style={{ height:45, width:45 }} />
                                }
                                
                            </div>
                            <div className='col-2' onClick={() => setValues(prev => ({ ...prev, circleColor:'cf92e1ff' }))}>
                                {values.circleColor === 'cf92e1ff' ? 
                                    <img src={imageRond2ok} alt='image couleur' style={{ height:45, width:45 }} />
                                : 
                                    <img src={imageRond2} alt='image couleur' style={{ height:45, width:45 }} />
                                }
                            </div>
                            <div className='col-2' onClick={() => setValues(prev => ({ ...prev, circleColor:'f6e2e5ff' }))}>
                                {values.circleColor === 'f6e2e5ff' ? 
                                    <img src={imageRond3ok} alt='image couleur' style={{ height:45, width:45 }} />
                                : 
                                    <img src={imageRond3} alt='image couleur' style={{ height:45, width:45 }} />
                                }
                            </div>
                            <div className='col-2' onClick={() => setValues(prev => ({ ...prev, circleColor:'f3bd6aff' }))}>
                                {values.circleColor === 'f3bd6aff' ? 
                                    <img src={imageRond4ok} alt='image couleur' style={{ height:45, width:45 }} />
                                : 
                                    <img src={imageRond4} alt='image couleur' style={{ height:45, width:45 }} />
                                }
                            </div>
                            <div className='col-2' onClick={() => setValues(prev => ({ ...prev, circleColor:'f1705fff' }))}>
                                {values.circleColor === 'f1705fff' ? 
                                    <img src={imageRond5ok} alt='image couleur' style={{ height:45, width:45 }} />
                                : 
                                    <img src={imageRond5} alt='image couleur' style={{ height:45, width:45 }} />
                                }
                            </div>
                        </div>

                        {/* BUTTON ENREGISTRER */}
                        <ButtonModalClose
                            onClick={() => 
                                handleAddStaff(
                                    values.surnameStaff, 
                                    values.nameStaff,
                                    values.circleColor,
                                    values.phoneStaff,
                            )}
                            title='Enregistrer'
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalStaff